import { createStore, combineReducers, applyMiddleware } from 'redux';
import { reducer as authReducer, loadUser } from 'redux-oidc';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import subscriptionReducer from './subscriptions/reducer';
import profileReducer from './profile/reducer';
import savedItemsReducer from './saveditems/reducer';
import userContentReducer from './content/reducer';
import announcementReducer from './announcement/reducer';
import { usageLogMiddleware } from './analytics/middleware';
import userManager from '../util/usermanager';
import elearnProfileReducer from './elearnprofile/reducer';
import mfaReducer from './mfa/reducer';
import selfRegistrationReducer from './selfregistration/reducer';
import addressTypesReducer from './addresstypes/reducer';
import membershipsReducer from './memberships/reducer';
import unifiedRegistrationReducer from './register/reducer';

const rootReducer = combineReducers({
  subscriptions: subscriptionReducer,
  auth: authReducer,
  profile: profileReducer,
  saveditems: savedItemsReducer,
  content: userContentReducer,
  announcement: announcementReducer,
  elearnProfile: elearnProfileReducer,
  selfregistration: selfRegistrationReducer,
  addressTypes: addressTypesReducer,
  memberships: membershipsReducer,
  mfaSettings: mfaReducer,
  unifiedRegistration: unifiedRegistrationReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default () => {
  const middlewares = [thunkMiddleware, usageLogMiddleware];

  const middleWareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );
  if (typeof userManager !== 'undefined') {
    loadUser(store, userManager);
  }
  return store;
};
